// Adapted from davinci-elections apps/web/src/theme/recipes/popover.ts @ 6e23f58
import { popoverAnatomy as parts } from '@chakra-ui/react/anatomy'
import { defineSlotRecipe } from '@chakra-ui/react'

const baseStyle = {
  content: {
    bg: 'bg.panel',
    padding: 1,
    borderWidth: '1px',
    borderColor: 'border',
    boxShadow: 'raised',
  },
  header: {
    p: 0,
  },
  body: {
    p: 0,
  },
  footer: {
    p: 0,
  },
}

export const Popover = defineSlotRecipe({
  slots: parts.keys(),
  base: baseStyle,
})
